import React from 'react';
import { BotIcon, CodeIcon, CogIcon, CpuIcon, LightbulbIcon, RadioIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PRODUCT_NAME, tomos } from '../data/content';
const ICONS = {
  cpu: CpuIcon,
  code: CodeIcon,
  radio: RadioIcon,
  cog: CogIcon,
  bulb: LightbulbIcon,
  bot: BotIcon
};

/* Colores de cada tomo, igual que en la portada del pack */
const TOMO_COLORS = ['bg-brand-blue', 'bg-brand-orange', 'bg-brand-green', 'bg-brand-red', 'bg-brand-violet', 'bg-brand-teal'];
export function SolutionSection() {
  return <section aria-labelledby="solucion" className="bg-brand-navy" data-id="element-161" data-mp="atw52n53ds6f">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-162" data-mp="5v19ekm1094w">
        <p className="font-display text-[0.62rem] font-bold uppercase tracking-[0.14em] text-brand-yellow" data-id="element-163" data-mp="kslctn39xw8y">
          La solución que estabas buscando — un sistema 6 en 1
        </p>
        <h2 id="solucion" className="mt-1.5 font-display text-base font-extrabold leading-tight text-white sm:text-xl" data-id="element-164" data-mp="frntv8afwy6e">
          6 tomos en un solo sistema, creados para enseñar paso a paso.
        </h2>
        <p className="mt-1 font-display text-[0.75rem] font-black uppercase leading-tight text-brand-yellow sm:text-sm" data-id="element-165" data-mp="3faslhjf66i8e">
          {PRODUCT_NAME}
        </p>
        <p className="mx-auto mt-1.5 max-w-xl text-[0.78rem] leading-snug text-white/80" data-id="element-166" data-mp="3k8ammnmy3t5u">
          No es simplemente otro ebook sobre Arduino. Es una ruta educativa que
          organiza los conocimientos fundamentales para que puedas enseñar desde
          electrónica y programación hasta sensores, automatización y proyectos
          completos de robótica.
        </p>

        <ol className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-167" data-mp="6uz5r6snxase">
          {tomos.map((tomo, i) => {
          const Icon = ICONS[tomo.icon];
          return <Reveal key={tomo.title} as="li" delay={i * 0.03} className="flex h-full overflow-hidden rounded-lg bg-white text-left text-brand-night" data-id="element-168" data-mp="gt57noegygx9" data-mpi={i}>
                <span className={`flex w-12 flex-shrink-0 flex-col items-center justify-center gap-1 text-white ${TOMO_COLORS[i]}`} data-id="element-169" data-mp="27z19iie3pqw0">
                  <span className="font-display text-[0.5rem] font-bold uppercase tracking-wider" data-id="element-170" data-mp="2hve3zihh08rt">
                    Tomo
                  </span>
                  <span className="font-num text-2xl leading-none" data-id="element-171" data-mp="2vlhn40l1zmd1">{i + 1}</span>
                  <Icon size={13} aria-hidden="true" data-id="element-172" data-mp="2rkxqqz8b0mry" />
                </span>
                <div className="p-2.5" data-id="element-173" data-mp="35lqmfnacdnwn">
                  <h3 className="sr-only" data-id="element-174" data-mp="35kp6p5idsd8l">Tomo {i + 1}</h3>
                  <p className="font-display text-[0.78rem] font-extrabold uppercase leading-tight" data-id="element-175" data-mp="30m44j0jkjjhi">
                    {tomo.title}
                  </p>
                  <p className="mt-0.5 text-[0.74rem] leading-snug text-brand-night/75" data-id="element-176" data-mp="1b9ag6mhjq9rs">
                    {tomo.desc}
                  </p>
                </div>
              </Reveal>;
        })}
        </ol>

        <CtaButton href={OFFER_ANCHOR} className="mt-3" data-id="element-177" data-mp="3mvccuyrgexn3">
          🚀 Sí, quiero comenzar ahora
        </CtaButton>
      </div>
    </section>;
}